export const createFormData = (data) => {
  const formData = new FormData()

  const appendToFormData = (key, value) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        appendToFormData(key, item)
      })
    } else {
      formData.append(key, value)
    }
  }
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item) => {
        appendToFormData(key, item)
      })
    } else {
      appendToFormData(key, data[key])
    }
  })

  return formData
}

export const isValidISO8601Format = (str) => {
  // Regular expression to match the exact format 'YYYY-MM-DDTHH:mm:ss.sssZ'
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/
  return regex.test(str)
}

export function isValidDateString(str) {
  // Regular expression to match 'Day Month DayOfMonth Year Time ZoneOffset (TimezoneName)'
  const regex = /^[A-Za-z]{3} [A-Za-z]{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} GMT[+-]\d{4} \([A-Za-z\s]+(?:\s[A-Za-z]+)*\)$/
  return regex.test(str)
}
